import { Router } from "./Router.js";
import { LocationUtils } from "../location/LocationUtils.js";
import { UrlUtils } from "@dooboostore/core";
class HashRouter extends Router {
  constructor(config) {
    super(config);
  }
  getSearchParams(data) {
    const hashSearch = LocationUtils.hashSearch(this.config.window);
    const searchParams = hashSearch ? new URLSearchParams(hashSearch) : new URL(this.config.window.document.location.href).searchParams;
    return UrlUtils.manipulateSearchParams(searchParams, data);
  }
  push(path, state) {
    if (path === "/") {
      return super.pushState(state?.data, state?.title, "/", state?.config);
    } else {
      return super.pushState(state?.data, state?.title, `#${this.toUrl(path)}`, state?.config);
    }
  }
  replace(path, state) {
    if (path === "/") {
      return super.replaceState(state?.data, state?.title, "/", state?.config);
    } else {
      return super.replaceState(state?.data, state?.title, `#${this.toUrl(path)}`, state?.config);
    }
  }
  setDeleteHashSearchParam(name, state) {
  }
  pushDeleteHashSearchParam(name, state) {
    const s = this.getHashSearchParams({ delete: Array.isArray(name) ? name : [name] });
    const size = Array.from(s.entries()).length;
    const href = `${this.config.window.location.pathname}${this.config.window.location.search}${size > 0 ? "#" + s.toString() : ""}`;
    super.pushState(state?.data, state?.title, href, state?.config);
  }
  pushDeleteSearchParam(name, state) {
    const s = this.getSearchParams({ delete: Array.isArray(name) ? name : [name] });
    this.push({ searchParams: s }, state);
  }
  pushAddSearchParam(params, state) {
    const s = this.getSearchParams({ append: params });
    this.push({ searchParams: s }, state);
  }
  pushUpsertSearchParam(params, state) {
    const s = this.getSearchParams();
    UrlUtils.upsertSearchParam(s, params);
    this.push({ searchParams: s }, state);
  }
  replaceDeleteHashSearchParam(name, state) {
    const s = this.getHashSearchParams({ delete: Array.isArray(name) ? name : [name] });
    const size = Array.from(s.entries()).length;
    const href = `${this.config.window.location.pathname}${this.config.window.location.search}${size > 0 ? "#" + s.toString() : ""}`;
    super.pushState(state?.data, state?.title, href, state?.config);
  }
  replaceDeleteSearchParam(name, state) {
    const s = this.getSearchParams({ delete: Array.isArray(name) ? name : [name] });
    this.push({ searchParams: s }, state);
  }
  replaceAddSearchParam(params, state) {
    const s = this.getSearchParams({ append: params });
    this.push({ searchParams: s }, state);
  }
  replaceUpsertSearchParam(params, state) {
    const s = this.getSearchParams();
    UrlUtils.upsertSearchParam(s, params);
    this.replace({ searchParams: s }, state);
  }
  getUrl() {
    return LocationUtils.hash(this.config.window) || "/";
  }
  getHref() {
    return this.config.window.location.href;
  }
  getPathName() {
    return LocationUtils.hashPath(this.config.window) || "/";
  }
  getSearch() {
    return LocationUtils.hashSearch(this.config.window);
  }
  getHashSearchParams(data) {
    const hash = this.config.window.location.hash;
    const queryIndex = hash.indexOf("?");
    const searchParams = queryIndex !== -1 ? new URLSearchParams(hash.slice(queryIndex + 1)) : new URLSearchParams();
    return UrlUtils.manipulateSearchParams(searchParams, data);
  }
}
export {
  HashRouter
};
//# sourceMappingURL=HashRouter.js.map
